import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useNuJobsStore from "../../../store/nujobs.store";
import { DownOutlined } from "@ant-design/icons";
import { Select } from "antd";
import AddComponent from "../../AddComponent/add";

import {
  Radio,
  Divider,
  Form,
  Input,
  message,
  Button,
  TimePicker,
  DatePicker,
  Card,
  Space,
  Checkbox,
  Collapse,
} from "antd";

import "./jobListingSearchResultFilter.scss";
import { ROLE_OPTIONS, ROLE_TYPE_OPTIONS } from "../../../helper/categoryconstants";

export default function JobListingSearchResultFilter({
  currentPageNumber,
  maxPerPage,
  filterJsonCallback,
  skillCallback,
  isAppliedPage = false,
  isFavPage = false,
  loggedIn = false,
}) {
  const navigate = useNavigate();

  const { getOSAllJds, lastJDsReq } = useNuJobsStore();
  const activeCategories = React.useMemo(() => {
    // 1. Favourites Page Fallback: If no specific categories are passed, show ALL categories.
    if (isAppliedPage || isFavPage) {
      return Object.keys(ROLE_OPTIONS || {});
    }

    // 2. Normal Search Page: Use the category from the Zustand store.
    if (Array.isArray(lastJDsReq?.category)) {
      return lastJDsReq.category;
    } else if (lastJDsReq?.category) {
      return [lastJDsReq.category];
    } else {
      return ["it"];
    }
  }, [isAppliedPage, isFavPage, lastJDsReq?.category]);

  const combinedRoleOptions = React.useMemo(() => {
    // 1. Get all options, including duplicates
    const allOptions = activeCategories.flatMap(
      (category) => ROLE_OPTIONS?.[category] || [],
    );

    // 2. Remove duplicates by creating a Map using the 'value' as the unique key
    const uniqueOptions = Array.from(
      new Map(allOptions.map((opt) => [opt.value, opt])).values(),
    );

    return uniqueOptions;
  }, [activeCategories]);

  const postingoptions = [
    { label: "Today", value: "Today" },
    { label: "1 Day", value: "1" },
    { label: "7 Days", value: "7" },
    { label: "15 Days", value: "15" },
    { label: "30 Days", value: "30" },
    { label: "45 Days", value: "45" },
    { label: "60 Days", value: "60" },
    { label: "90 Days", value: "90" },
    { label: "180 Days", value: "180" },
    { label: "365 Days", value: "365" },
    { label: "Older", value: "Older" },
    { label: "All", value: "All" },    
    ];
  const noticePeriodoptions = [
    { label: "Immediate", value: "14" },
    { label: "15 Days", value: "15" },
    { label: "30 Days", value: "30" },
    { label: "45 Days", value: "45" },
    { label: "60 Days", value: "60" },
    { label: "90 Days", value: "90" },
    ];

   const jdValuesTmp = {
                  experience: {"min":lastJDsReq?.minexp, "max":lastJDsReq?.maxexp},
                  ctcrange: {"min":lastJDsReq?.minctc, "max":lastJDsReq?.maxctc},
                  noticeperiod: lastJDsReq?.noticeperiod,
                  postingdate: lastJDsReq?.postingdate,           
                  workmode: lastJDsReq?.workmode,
                  diversity: lastJDsReq?.diversity,
                  role: lastJDsReq?.role,
                  roletype: lastJDsReq?.roletype,
                  companytype: lastJDsReq?.companytype,
                  jobfor: lastJDsReq?.jobfor,
              };
  const encodeJson = (values) =>{
        let encodedJsonValues ={};
        //console.log("Filtered Values", values)
        encodedJsonValues.keywords= lastJDsReq?.keywords;
        encodedJsonValues.city=lastJDsReq?.city;
        encodedJsonValues.country=lastJDsReq?.country;
        encodedJsonValues.category=lastJDsReq?.category;  
        encodedJsonValues.timestamp= lastJDsReq?.timestamp;  
        //from values
        encodedJsonValues.pagenum= currentPageNumber;
        encodedJsonValues.maxPerPage= maxPerPage;
        // ✅ FIXED: convert to numbers
        encodedJsonValues.minexp = values.experience?.min
            ? parseInt(values.experience.min, 10)
            : 0;
        encodedJsonValues.maxexp = values.experience?.max
            ? parseInt(values.experience.max, 10)
            : 0;
   
        encodedJsonValues.minctc = values.ctcrange?.min
            ? parseFloat(values.ctcrange.min)
            : 0;
        encodedJsonValues.maxctc = values.ctcrange?.max
            ? parseFloat(values.ctcrange.max)
            : 0;
  
        // rest
        encodedJsonValues.noticeperiod = values.noticeperiod || [];
        encodedJsonValues.postingdate=values.postingdate || [];
        encodedJsonValues.workmode=values.workmode;  
        encodedJsonValues.diversity= values.diversity;  
        encodedJsonValues.role= values.role
        encodedJsonValues.roletype= values.roletype
        encodedJsonValues.companytype= values.companytype
        encodedJsonValues.jobfor= values.jobfor
        if(loggedIn){
          const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            encodedJsonValues.pendingsync = JSON.parse(
                    localStorage.getItem("NuJobsPendingSync") || "[]"
                );  
          encodedJsonValues.signedin=true; 
          encodedJsonValues.nujuid= userData.nujuid   
          encodedJsonValues.nujoid= userData.nujoid                     
        }   

        return encodedJsonValues
  }

  const handleFormSubmit = (values) => {
        const jasonValues = encodeJson(values)
        if(filterJsonCallback) filterJsonCallback(jasonValues)
        if(skillCallback != null){
          skillCallback(jasonValues,null)
        }else{
          getOSAllJds(jasonValues) 
        }
  }; 

  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields(); // 🔥 resets all fields
    const resetValues = encodeJson({
        experience: { min: null, max: null },
        ctcrange: { min: null, max: null },
        noticeperiod: [],
        postingdate: [],
        workmode: null,
        diversity: null,
        role: [],
        roletype: [],
        companytype: null,
        jobfor: null,
    });
    form.setFieldsValue({
    experience: { min: null, max: null },
    ctcrange: { min: null, max: null },
    noticeperiod: [],
    postingdate: [],
    workmode: null,
    diversity: null,
    role: [],
    roletype: [],
    companytype: null,
    jobfor: null,
    });    

    if(filterJsonCallback) filterJsonCallback(resetValues)
    if(skillCallback != null){
          skillCallback(resetValues,null)
    }else{
          getOSAllJds(resetValues) 
    }
  };

  return (
    <div className="searchResultsFilter-wrapper">
        Select More Filters
            <Form
                form={form}
                className="searchResultsFilter-wrapper"
                name="jobListing-search"
                autoComplete="off"
                onFinish={handleFormSubmit}
                layout="vertical"
                initialValues={jdValuesTmp}
            >
                    <Form.Item
                    className="searchResultsFilter-field-item"
                    label="Experience (Yrs)"
                    >
                    <Space.Compact style={{ width: "100%" }}>
                        <Form.Item
                        name={['experience', 'min']}
                        noStyle
                        >
                        <Input
                            style={{ width: "30%" ,height:"40%"}}
                            placeholder="Min"
                            type="number"
                        />
                        </Form.Item>

                        <span style={{ width: "10%", textAlign: "center", lineHeight: "32px" }}>
                        to
                        </span>

                        <Form.Item
                        name={['experience', 'max']}
                        noStyle
                        >
                        <Input
                            style={{ width: "30%" ,height:"40%"}}
                            placeholder="Max"
                            type="number"
                        />
                        </Form.Item>
                    </Space.Compact>
                    </Form.Item>                  
                    <Form.Item
                        className="searchResultsFilter-field-item"
                        label="Salary Range (LPA)"
                    >
                        <Space.Compact style={{ width: "100%" }}>
                        
                        <Form.Item
                            name={['ctcrange', 'min']}
                            noStyle
                        >
                            <Input
                            style={{ width: "30%",height:"40%" }}
                            placeholder="Min"
                            type="number"
                            />
                        </Form.Item>

                        <span style={{ width: "10%", textAlign: "center", lineHeight: "32px" }}>
                            to
                        </span>

                        <Form.Item
                            name={['ctcrange', 'max']}
                            noStyle
                        >
                            <Input
                            style={{ width: "30%" ,height:"40%" }}
                            placeholder="Max"
                            type="number"
                            />
                        </Form.Item>
                        </Space.Compact>
                    </Form.Item>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Posting Date" key="1">
            <Form.Item name="postingdate" noStyle>
              <Checkbox.Group className="searchResultsFilter-radio-wrapper">
                {postingoptions.map((opt) => (
                  <Checkbox key={opt.value} value={opt.value}>
                    {opt.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Notice Period" key="1">
            <Form.Item name="noticeperiod" noStyle>
              <Checkbox.Group className="searchResultsFilter-radio-wrapper">
                {noticePeriodoptions.map((opt) => (
                  <Checkbox key={opt.value} value={opt.value}>
                    {opt.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Work Mode" key="1">
            <Form.Item name="workmode" noStyle>
                <Radio.Group className="searchResultsFilter-radio-wrapper">
                  <Radio className="radio-option" value={"WFO"}>
                    WFO
                  </Radio>
                  <Radio className="radio-option" value={"WFH"}>
                    WFH
                  </Radio>
                  <Radio className="radio-option" value={"Hybrid"}>
                    Hybrid
                  </Radio>
                  <Radio className="radio-option" value={"Remote"}>
                    Remote
                  </Radio>
                  <Radio className="radio-option" value={"Any"}>
                    Any
                  </Radio>                  
                </Radio.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Job Role" key="1">
            <Form.Item
              className="searchResultsFilter-field-item"
              name="role"
              noStyle
            >
              {activeCategories.length === 1 ? (
                <Checkbox.Group className="searchResultsFilter-radio-wrapper">
                  {ROLE_OPTIONS?.[activeCategories[0]]?.map((opt) => (
                    <Checkbox key={opt.value} value={opt.value}>
                      {opt.label}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              ) : (
                <Select
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Search and select roles..."
                  style={{ width: "100%" }}
                  options={combinedRoleOptions}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              )}
            </Form.Item>
          </Collapse.Panel>
        </Collapse>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Role Type" key="1">
            <Form.Item name="roletype" noStyle>
              <Checkbox.Group className="searchResultsFilter-radio-wrapper">
                {ROLE_TYPE_OPTIONS.map((opt) => (
                  <Checkbox key={opt.value} value={opt.value}>
                    {opt.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Company Type" key="1">
            <Form.Item name="companytype" noStyle>
              <Radio.Group className="searchResultsFilter-radio-wrapper">
                <Radio className="radio-option" value={"Product Company"}>
                  Product
                </Radio>
                <Radio className="radio-option" value={"Service Company"}>
                  Services
                </Radio>
                <Radio className="radio-option" value={"Any"}>
                  Any
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>

        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Job For" key="1">
            <Form.Item name="jobfor" noStyle>
              <Radio.Group className="searchResultsFilter-radio-wrapper">
                <Radio className="radio-option" value={"Interns"}>
                  Interns
                </Radio>
                <Radio className="radio-option" value={"Freshers"}>
                  Freshers
                </Radio>
                <Radio className="radio-option" value={"Experienced"}>
                  Experienced
                </Radio>
                <Radio className="radio-option" value={"Any"}>
                  Any
                </Radio>                
              </Radio.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>
        <Collapse ghost expandIconPosition="end">
          <Collapse.Panel header="Diversity Only" key="1">
            <Form.Item
              className="searchResultsFilter-field-item"
              name="diversity"
            >
              <Radio.Group
                defaultValue={false}
                className="searchResultsFilter-radio-wrapper"
              >
                <Radio className="radio-option" value={"Yes"}>
                  Yes
                </Radio>
                <Radio className="radio-option" value={"No"}>
                  No
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Collapse.Panel>
        </Collapse>
        <Button
          className="jobListing-search-button"
          type="primary"
          htmlType="submit"
        >
          Apply Filter
        </Button>
        <Button className="jobListing-search-reset" onClick={onReset}>
          Reset Filter
        </Button>
      </Form>
       <AddComponent />
    </div>
  );
}
